import { Link } from "react-router";
import { Icon } from "@/components/ui/Icon";

const LINKS = [
  { to: "/trade/list", label: "Trades" },
  { to: "/dashboard", label: "Dashboard" },
  { to: "/performance", label: "Performance" },
  { to: "/resources", label: "Resources" },
  { to: "/faqs", label: "F.A.Q.s" },
];

export function Footer() {
  return (
    <footer className="mt-auto border-t-2 border-ink bg-ink text-paper">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-8 px-6 py-10">
        <div>
          <p className="text-lg font-black tracking-tighter">TRADE-R</p>
          <p className="mt-1 font-mono text-[0.65rem] tracking-[0.2em] text-paper/50 uppercase">
            Trade to a plan · v2.0.0
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="font-mono text-xs tracking-[0.15em] text-paper/70 uppercase hover:text-accent"
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="flex gap-4">
          <a
            href="https://github.com/adamjarling"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="hover:text-accent"
          >
            <Icon name="github" size="lg" />
          </a>
          <a
            href="https://twitter.com/adamjarling"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="hover:text-accent"
          >
            <Icon name="twitter" size="lg" />
          </a>
        </div>
      </div>
    </footer>
  );
}
